module.exports = __webpack_public_path__ + "img/products_big_can_bubblegum.150e14cd.png";